import React, { useState, useEffect } from 'react';
import { useHttp } from '../../hooks/httpHook';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import VacancyCard from '../../components/VacancyCard';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { connect, useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import Nirvana from '../../assets/Nirvana.PNG';
import Pagination from '@mui/material/Pagination';
import { total } from '../../redux/actions/clsActions';
import { vacancies, } from '../../redux/actions/filterActions';

const useStyles = makeStyles((total) => (
  {
    root: {

      "& > *": {
        justifyContent: "center",
        display: 'flex'
      },
      '& ul > li:not(:first-child):not(:last-child) > .Mui-selected': {
        backgroundColor: '#3C70F1',
        color: '#fff',
        boxShadow: '0px 0px 10px rgba(37, 114, 250, 0.45)'
      },
      "& .MuiPaginationItem-root": {
        '&:hover': {
          backgroundColor: "#fafafa00",
          borderRadius: 10,
        },
        '&:active': {
          borderRadius: 10,
          '& .page-link': {
            backgroundColor: 'green !important'
          }
        },
      },
      "& .MuiPaginationItem-page": {
        color: '#9FAABC',
        borderRadius: 10,
        backgroundColor: "#fafafa",
      },

      "& .MuiPaginationItem-icon": {
        backgroundColor: "#fafafa",
        minHeight: 40,
        minWidth: 40,
        borderRadius: 10,
        '&:hover': {
          backgroundColor: "#fafafa",
          borderRadius: 10,
        },
      },
    },
    resultHighLight:{
      color:'#ff0000'
    },
    headerText:{
      color: '#162946'
    },
    paper: {
      minWidth: 978,
      maxWidth: 978,
      marginTop: 38,
      marginLeft: 25,
      minHeight: 1413,
      maxHeight: 1413,
      borderRadius: 20,
    },
    header: {
      paddingLeft: 40,
      paddingTop: 81,
      marginBottom: -5,
    },
    nirvana: {
      marginLeft: 289,
      marginTop: 207,
    },
    placeholder: {
      marginLeft: 300,
      marginTop: 100,
      align: 'center',
      minWidth: 378,
      minHeight: 52,
    },
    cardbox: {
      marginTop: 0,
      marginBottom: 10,
      marginLeft: 10,
      marginRight: 10,
    },
    pagingTool: {

      bottom: 98,
      maxHeight: 40,
      minHeight: 40,
      padding: 5,
      backgroundColor: '#fafafa',
      borderRadius: 10,
      maxWidth: 515,
      marginTop: 5,
    },
    pagingBox: {
      position: 'absolute',
      top: 1361,
      maxHeight: 60,
      overflow: 'hidden',
      marginLeft: 89,
    },
    // pagingColor:{
    //   maxWidth: 700,
    //   padding: 5,
    // }
  }));

const SearchResult = ({ vacancies, total }) => {
  const currentVacancies = useSelector((state) => state.filterReducer.vacancies);
  const searched = useSelector((state) => state.clsReducer.searched);
  const [currentPage, setCurrentPage] = useState(1);
  const currentTotal = useSelector((state) => state.clsReducer.total);
  const currentFilter = useSelector((state) => state.filterReducer);
  const { request } = useHttp();
  const classes = useStyles();

  let [headerText, setHeaderText] = useState(``);
  let [placeHolder, setPlaceHolder] = useState("");
  let [isFirstLoad, setIsFirstLoad]= useState("");


  useEffect(() => {

    setIsFirstLoad(true);
    if (searched) {
      setIsFirstLoad(false);
      setHeaderText(`${currentTotal}`);
      setPlaceHolder('Попробуйте изменить или уточнить запрос. Например: город, должность или стек');
      setCurrentPage(1);
    }
  }, [currentTotal]);

  const getPagesAmount = (totalAmount) => {
    if (!searched || totalAmount <= 8) {
      return 1;
    }
    if (totalAmount % 8 > 0) {
      return Math.floor(totalAmount / 8) + 1;
    }

    return Math.floor(totalAmount / 8);
  };

  const handlePageChange = async (event, value) => {
    currentFilter.vacancies = [];
    setCurrentPage(Number.parseInt(value));
    request.params = currentFilter;
    request.params.page = Number.parseInt(value);
    const response = await request(
      `/filter/filtered`,
      'get',
      currentFilter
    );

    if (response && !response.error) {
      total(response.total);
      return vacancies(response.vacancies);
    }
  };


  return (

    <Paper elevation={0} className={classes.paper}>
      <Box className={classes.header}>
        <Typography variant="h5" gutterBottom className={classes.headerText}>

          {(() => {
            if (isFirstLoad) {
                return <b>Сейчас на Head<span className={classes.resultHighLight}>.</span>z более <span
                    className={classes.resultHighLight}>10 000</span> вакансий от топовых компаний</b>

              } else{
                return  <b>Head<span className={classes.resultHighLight}>.</span>z нашел <span class={classes.resultHighLight} > {headerText} </span> вакансий по вашему запросу</b>
             }

          })()}


        </Typography>
      </Box>
      <Box visibility="visible">
        <Grid
          className={classes.cardbox}
          container
          direction="row"
          justifyContent="flex-start"

          height="100%"
        >
          {
            currentVacancies && Array.isArray(currentVacancies) && currentVacancies.length ?
              <>{
                currentVacancies.map((option, index) => (
                  <VacancyCard key={index} value={option} xs visibility="hidden" />
                ))}</> : <></>
          }

          <Box className={classes.pagingBox}>
            <Box className={classes.root}  >
              <Box >
                <Pagination count={getPagesAmount(currentTotal)}
                  shape="rounded"
                  classes={{ root: classes.pagingTool }}
                  page={currentPage}
                  style={{
                    marginLeft: getPagesAmount(currentTotal) > 10? 156 :  345 - (getPagesAmount(currentTotal) * 25),
                    minWidth: getPagesAmount(currentTotal) > 10? 520 : getPagesAmount(currentTotal)*40 + 120,
                  }}
                  size="large" siblingCount={1}
                  onChange={(e, v) => handlePageChange(e, v)}
                  boundaryCount={2}
                  overflow="hidden" xs={9}>
                </Pagination>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Box>{
        currentVacancies && currentVacancies.length ?
          <Box></Box> :
          <>
            <Box className={classes.nirvana}>
              <img
                src={Nirvana}
                alt="robot"
              />
            </Box>
            <Box>
              <Typography variant="body1" align="center" display="block" className={classes.placeholder}>
                {placeHolder}
              </Typography>
            </Box>
          </>
      }

    </Paper>
  );
}

const mapStateToProps = state => ({
  vacancies: state.filterReducer.vacancies,
  total: state.clsReducer.total,
});

export default connect(mapStateToProps, { vacancies, total })(SearchResult)